// redux/slices/collapseSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCustomerDetailsCollapsed: false,
  isHomeDetailsCollapsed: false,
  isPostalAddressDetailsCollapsed: false,
  isIdentificationDetailsCollapsed: false,
  isPreviousFundDetailsCollapsed: false,
  isPaymentDetailsCollapsed: false,
  isAcknolodgmentCollapsed: false,
  isAGRApplicationCollapsed: false,
  isBupaYourChoiceExtraSelectioCollapsed: false,
};

const collapseSlice = createSlice({
  name: 'collapse',
  initialState,
  reducers: {
    setCustomerDetails: (state, action) => {
      state.isCustomerDetailsCollapsed = action.payload;
    },
    setHomeDetails: (state, action) => {
      state.isHomeDetailsCollapsed = action.payload;
    },
    setPostalAddressDetails: (state, action) => {
      state.isPostalAddressDetailsCollapsed = action.payload;
    },
    setIdentificationDetails: (state, action) => {
      state.isIdentificationDetailsCollapsed = action.payload;
    },
    setPreviousFundDetails: (state, action) => {
      state.isPreviousFundDetailsCollapsed = action.payload;
    },
    setPaymentDetails: (state, action) => {
      state.isPaymentDetailsCollapsed = action.payload;
    },
    setAcknolodgment: (state, action) => {
      state.isAcknolodgmentCollapsed = action.payload;
    },
    setAGRApplication: (state, action) => {
      state.isAGRApplicationCollapsed = action.payload;
    },
    setBupaYourChoiceExtraSelectio: (state, action) => {
      state.isBupaYourChoiceExtraSelectioCollapsed = action.payload;
    },
  },
});

export const {
  setCustomerDetails,
  setHomeDetails,
  setPostalAddressDetails,
  setIdentificationDetails,
  setPreviousFundDetails,
  setPaymentDetails,
  setAcknolodgment,
  setAGRApplication,
  setBupaYourChoiceExtraSelectio,
} = collapseSlice.actions;

export default collapseSlice.reducer;
